// Sabitler
export const CONSTANTS = {
  dgazEnerjisi: 8250, // kcal/sm³
  kazanVerimi: 0.92,  // %92
  elektrikCO2: 0.478, // kg CO2/kWh
  dgazCO2: 2.34,      // kg CO2/m³
  elektrikFiyat: 4,   // TL/kWh
  gazFiyat: 12,       // TL/m³
  euroTlParitesi: 44
};

// Demo sayfasındaki COP tablosu
const copTable = [
  [5.74, 5.02, 4.35, 3.73, 3.16, 2.88, 2.84, 2.73, 2.52, 2.20, 2.16, 2.06],
  [6.65, 5.80, 4.97, 4.20, 3.25, 2.90, 3.04, 2.86, 2.65, 2.34, 2.29, 2.18],
  [8.05, 6.97, 5.89, 4.86, 3.58, 3.19, 3.23, 3.04, 2.87, 2.48, 2.42, 2.31],
  [8.87, 7.67, 6.42, 5.25, 4.06, 3.61, 3.48, 3.27, 3.07, 2.66, 2.59, 2.47],
  [null, null, 5.91, 5.22, 4.62, 4.11, 3.74, 3.51, 3.15, 2.85, 2.78, 2.62],
  [null, null, 6.62, 5.86, 5.20, 4.61, 4.10, 3.88, 3.57, 3.31, 3.21, 2.99],
  [null, null, null, null, 5.78, 5.17, 4.62, 4.23, 3.89, 3.58, 3.48, 3.22],
  [null, null, null, null, 6.71, 6.03, 5.39, 4.62, 4.23, 3.89, 3.77, 3.48],
  [null, null, null, null, null, null, null, null, 4.54, 4.24, 4.10, 3.77],
  [null, null, null, null, null, null, null, null, null, null, 4.42, 4.13],
  [null, null, null, null, null, null, null, null, null, null, null, 4.08]
];

// Isıtma ve soğutma sıcaklık değerleri - demo sayfasındaki ile aynı sıralama
const heatingTemperatures = [95, 90, 85, 80, 75, 70, 65, 60, 55, 50, 45];
const coolingTemperatures = [55, 50, 45, 40, 35, 30, 25, 20, 15, 10, 7, 2];

// Demo sayfasından doğrudan alınan interpolasyon fonksiyonu
function interpolate(x1, y1, x2, y2, x) {
  if (x1 === x2) {
    return (y1 + y2) / 2; // If x1 == x2, return average of y1 and y2
  }
  return y1 + ((y2 - y1) / (x2 - x1)) * (x - x1);
}

// Demo sayfasından doğrudan alınan indeks bulma fonksiyonu
function findIndicesDescending(arr, value) {
  if (value >= arr[0]) {
    return [0, 0]; // Value is above the highest value
  }
  if (value <= arr[arr.length - 1]) {
    return [arr.length - 1, arr.length - 1]; // Value is below the lowest value
  }
  for (let i = 0; i < arr.length - 1; i++) {
    if (arr[i] >= value && value >= arr[i + 1]) {
      return [i, i + 1];
    }
  }
  return [arr.length - 1, arr.length - 1]; // Default to last index
}

// Demo sayfasından doğrudan alınan COP değeri hesaplama fonksiyonu
export const calculateCOP = (coolingTemperature, heatingTemperature) => {
  // Sıcaklıkların geçerli aralıkta olduğundan emin ol
  heatingTemperature = Math.min(Math.max(heatingTemperature, 45), 95);
  coolingTemperature = Math.min(Math.max(coolingTemperature, 2), 55);

  // Find indices for heating temperatures
  let [heatingIndex1, heatingIndex2] = findIndicesDescending(heatingTemperatures, heatingTemperature);

  // Find indices for cooling temperatures
  let [coolingIndex1, coolingIndex2] = findIndicesDescending(coolingTemperatures, coolingTemperature);

  // Get the temperatures for interpolation
  let heatingTemp1 = heatingTemperatures[heatingIndex1];
  let heatingTemp2 = heatingTemperatures[heatingIndex2];

  let coolingTemp1 = coolingTemperatures[coolingIndex1];
  let coolingTemp2 = coolingTemperatures[coolingIndex2];

  // Get the COP values
  let cop11 = copTable[heatingIndex1][coolingIndex1];
  let cop12 = copTable[heatingIndex1][coolingIndex2];
  let cop21 = copTable[heatingIndex2][coolingIndex1];
  let cop22 = copTable[heatingIndex2][coolingIndex2];

  // Handle null values
  if (cop11 === null || cop12 === null || cop21 === null || cop22 === null) {
    // Return the first non-null COP value
    let copValues = [cop11, cop12, cop21, cop22].filter(cop => cop !== null && cop !== undefined);
    let validCop = copValues.length > 0 ? copValues[0] : 0;
    return validCop;
  }

  // Interpolate over cooling temperatures
  let copH1 = interpolate(coolingTemp1, cop11, coolingTemp2, cop12, coolingTemperature);
  let copH2 = interpolate(coolingTemp1, cop21, coolingTemp2, cop22, coolingTemperature);

  // Interpolate over heating temperatures
  let finalCop = interpolate(heatingTemp1, copH1, heatingTemp2, copH2, heatingTemperature);

  return parseFloat(finalCop.toFixed(2));
};

// Isıtma kapasitesi değiştiğinde soğutma kapasitesini hesapla
export const calculateCoolingFromHeating = (heatingCapacity, cop) => {
  if (cop <= 1) {
    console.error('Geçersiz COP değeri:', cop);
    return heatingCapacity * 0.5;
  }
  
  // Demo sayfasındaki birebir aynı formül
  const coolingCapacity = heatingCapacity * (cop - 1) / cop;
  return Math.round(coolingCapacity);
};

// Soğutma kapasitesi değiştiğinde ısıtma kapasitesini hesapla
export const calculateHeatingFromCooling = (coolingCapacity, cop) => {
  if (cop <= 1) {
    console.error('Geçersiz COP değeri:', cop);
    return coolingCapacity * 2;
  }
  
  // Demo sayfasındaki birebir aynı formül
  const heatingCapacity = coolingCapacity * cop / (cop - 1);
  return Math.round(heatingCapacity);
};

// TCMB'den Euro kurunu çekmek için fonksiyon - CapRover Backend üzerinden
export async function fetchEuroRate() {
  try {
    // Eski yöntem (Proxy) sadece development ortamında çalışıyordu.
    // Production'da (Firebase) çalışması için backend üzerinden çekiyoruz.
    const API_URL = "https://escon-mail-services.datarapor.com/exchange-rate";
    
    const response = await fetch(API_URL);
    
    if (!response.ok) {
      console.warn(`Döviz servisi yanıt vermedi (${response.status}), varsayılan değer (45) kullanılıyor.`);
      return 45; 
    }
    
    const data = await response.json();
    
    if (data.success && data.rate) {
      // console.log("Güncel Euro Kuru:", data.rate);
      return data.rate;
    }
    
    return 45;
  } catch (error) {
    console.error("Kur çekme hatası (Backend):", error);
    // console.log("Varsayılan Euro kuru (45) kullanılıyor.");
    return 45;
  }
}

// Tüm sistem sonuçlarını hesapla - DEMO sayfasıyla birebir aynı, dinamik kur ile
export async function calculateSystemResultsAsync(system, globalParams, solarEnabled = false) {
  // Güncel Euro/TL kurunu çek
  const euroTlParitesi = await fetchEuroRate();
  
  // Normal hesaplamayı çağır
  return calculateSystemResults(system, globalParams, solarEnabled, euroTlParitesi);
}

// Tüm sistem sonuçlarını hesapla - DEMO sayfasıyla birebir aynı
export function calculateSystemResults(system, globalParams, solarEnabled = false, customEuroRate = null) {
 
  // Sistem değerleri
  const {
    type = 'chiller',
    heatingCapacity = 500,
    heatingTemperature = 60,
    coolingCapacity = 400,
    coolingTemperature = 20,
    chillerCop = 6.5,
    workingHours = 5000
  } = system;
  
  // Demo sayfasındaki sabitler - birebir aynı değerler
  // Euro kurunu sırasıyla: customEuroRate -> globalParams.eurRate -> CONSTANTS.euroTlParitesi şeklinde kontrol et
  const euroTlParitesi = customEuroRate || globalParams?.eurRate || CONSTANTS.euroTlParitesi; 
  const dgazEnerjisi = 8250; // kcal/sm³
 
  // Global parametrelerden gelen değerleri kullan, yoksa sabitleri kullan
  const elektrikBirimFiyat = globalParams?.electricityPrice || CONSTANTS.elektrikFiyat; // TL/kWh
  const dogalgazBirimFiyat = globalParams?.gasPrice || CONSTANTS.gazFiyat; // TL/m³
  


  const kazanVerimi = 0.92;
  
  // Demo sayfasındaki hesaplama adımları
  
  // 1. COP hesaplama
  const heatPumpCop = calculateCOP(coolingTemperature, heatingTemperature);
  
  // 2. Elektrik tüketimleri (kW)
  //const chillerElektrikTuketimi = coolingCapacity / chillerCop;

  // 2. Elektrik tüketimleri (kW)
  let chillerElektrikTuketimi = 0;

 
  // Sistem tipine göre elektrik tüketimini belirle
  if (type === 'chiller') {
    // Chiller için mevcut formül
    chillerElektrikTuketimi = coolingCapacity / chillerCop;
  } else if (type === 'coolingTower') {
    // Soğutma kulesi için slider'dan alınan değer
    chillerElektrikTuketimi = system.towerPower || coolingCapacity / 100; // Eğer belirtilmemişse varsayılan değer
  } else if (type === 'heatRecovery') {
    // Atık ısı için 0
    chillerElektrikTuketimi = 0;
  }




  const isPompasıElektrikTuketimi = heatingCapacity / heatPumpCop;
  
  // 3. Toplam elektrik tüketimleri (kWh)
  const totalChillerElektrikTuketimi = chillerElektrikTuketimi * workingHours;
  const totalIsPompasıElektrikTuketimi = isPompasıElektrikTuketimi * workingHours;
  
  // 4. Doğalgaz tüketimi hesaplama (m³/saat)
  const dgazTuketimi = (heatingCapacity * 860) / (dgazEnerjisi * kazanVerimi);
  const totalDgazTuketimi = dgazTuketimi * workingHours;
  
  // 5. Maliyetler (TL) - DEMO SAYFASINDAKİ BİREBİR HESAPLAMA
  const dgazGideri = totalDgazTuketimi * dogalgazBirimFiyat;
  const chillerGideri = totalChillerElektrikTuketimi * elektrikBirimFiyat;
  const isPompasıGideri = totalIsPompasıElektrikTuketimi * elektrikBirimFiyat;
  
  // 'type' değişkenini kullanarak ESLint hatasını düzeltelim - log'u kaldıralım
  const systemType = type; // 'chiller' veya 'coolingTower' - console.log(systemType) satırını kaldırdık
  
  // 6. Tasarruf hesaplama (K TL ve Euro) - DEMO SAYFASINDAKİ BİREBİR HESAPLAMA
  const tasarrufTl = (dgazGideri + chillerGideri - isPompasıGideri) / 1000;
  const tasarrufEuro = tasarrufTl / euroTlParitesi;
  
  // 7. Demo sayfasındaki gibi enerji ve CO2 hesaplama
  const totalEnergy = parseFloat(((totalChillerElektrikTuketimi + totalIsPompasıElektrikTuketimi) / 1000).toFixed(1));

  const dogalagazco2 = totalDgazTuketimi * CONSTANTS.dgazCO2 / 1000;
  const elkCO2 = (totalIsPompasıElektrikTuketimi - totalChillerElektrikTuketimi) * 0.478 / 1000;
  const TotalCO2 = Math.max(0, dogalagazco2 - elkCO2); // Negatif değerleri sıfıra çek

  // Solar aktifse CO2 değerini azaltalım (daha basit bir yaklaşım)
  // Ancak burada hesaplayalım, UI'da değil
  let co2Emission;
  if (solarEnabled) {
    co2Emission = TotalCO2 * 0.5; // Solar aktifse %50 azalt
    console.log("Solar AKTIF: CO2 azaltıldı", { önceki: TotalCO2, yeni: co2Emission });
  } else {
    co2Emission = dogalagazco2; // Solar pasifse normal değer
    console.log("Solar PASIF: Normal CO2", { değer: co2Emission });
  }

   
  // Sonuçları döndür
  return {
    cop: heatPumpCop,
    energy: totalEnergy, // MWh
    co2: co2Emission, // Hesaplanmış CO2 değeri
    savings: tasarrufEuro, // K Euro
    euroRate: euroTlParitesi, // Güncel Euro/TL kuru
    systemType, // ESLint hatasını düzeltmek için kullanıldı
    heatingCapacity, // Isıl kapasite (kW) — yatırım maliyeti hesabı için

    // Diğer hesaplanan değerler
    chillerElektrikTuketimi,
    isPompasıElektrikTuketimi,
    totalChillerElektrikTuketimi,
    totalIsPompasıElektrikTuketimi,
    dgazTuketimi,
    totalDgazTuketimi,
    dgazGideri,
    chillerGideri,
    isPompasıGideri
  };
}